import { Injectable } from '@angular/core';
import { Route, PreloadingStrategy, Router,  } from '@angular/router';
import { Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})

export class CustomPreloadingStrategy implements PreloadingStrategy {
    constructor(private router: Router ){}

  preload(route: Route, load: () => Observable<any>): Observable<any> {
    return this.shouldPreload(route) ? load() : of(null);
  }
  shouldPreload(route: Route): boolean {
    const currentUrl = this.router.url;
    if(route.data){
      return currentUrl.includes(route.data['preload']);
    }
    return false;
  }
}